import gql from 'graphql-tag';

const MealPlanFragment = gql`
  fragment MealPlan on MealPlan {
    mealPlanUserId
    name
    stipendBalance
    cashBalance
    discount
    chainId
  }
`;

export default MealPlanFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/MealPlanFragment.js